import { render, staticRenderFns } from "./TheComputerLeaseEditForm.vue?vue&type=template&id=b0ddd80e&"
import script from "./TheComputerLeaseEditForm.vue?vue&type=script&lang=js&"
export * from "./TheComputerLeaseEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports